export function getPersonPageLink(personGroupId?: string|null): string {
  return `/recognition/person/${personGroupId}`;
}